import Vue from 'vue';

export default function() {
	Vue.$ofsCrud.addResource({
		name: 'fulfilment-override',
		pluralName: 'fulfilment-overrides',
		transport: 'davinci',
		options: {
			namespaced: true
		}
	});
}
